"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.districtSchema = exports.districtReferenceSchema = void 0;
const zod_1 = require("zod");
const districtKeySchema = zod_1.z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Human-friendly unique key of a district in the hyphen-separated lowercased format");
exports.districtReferenceSchema = zod_1.z.object({ key: districtKeySchema }).strict().describe("Reference to a district of an election");
const districtKindSchema = zod_1.z
    .enum(["municipality", "municipal-district", "electoral-district", "region"])
    .describe("Kind of the territorial unit: municipality (e.g. Brno), municipal-district (e.g. Praha 6), electoral-district (purpose-drawn, e.g. a Senate constituency), or region (e.g. kraj)");
exports.districtSchema = zod_1.z
    .object({
    key: districtKeySchema,
    code: zod_1.z.string().describe("Official district code assigned by the election authority").optional(),
    kind: districtKindSchema,
    title: zod_1.z.string().describe("Human-readable name of the district"),
    shortTitle: zod_1.z.string().max(25).describe("Short name of the district with a maximum of 25 characters").optional(),
    parent: districtKeySchema.describe("Key of the parent district within the same election").optional(),
})
    .strict()
    .describe("Geographical area of an election");
